export default __webpack_public_path__ + "static/aid_character_face-42672e4d6f3391757618f717b86409dd.svg";